export class Palpation {
  private static _values: Palpation[] = [];
  private static _lookup: Map<number, Palpation> = new Map();

  static fromId(id: number) {
    const instance = Palpation._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid Palpation.id: ' + id);
    }
    return instance;
  }

  static values(): Palpation[] {
    return [...Palpation._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Palpation._values.push(this);
    Palpation._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Palpation: ' + this.id + ", label='" + this.label + "'>";
  }
}
